// extracted by mini-css-extract-plugin
module.exports = {"datepicker":"DateRange_datepicker__AxzA7","dropdown":"DateRange_dropdown__fXr1k"};